<ng-template #blockTemplate>
  <div class="block-ui-template">
    <img src="/assets/img/memorabid-logo-white.svg" alt="Memorabid" />
  </div>
</ng-template>

@if(withLoader()) {
<block-ui [template]="blockTemplate">
  <div class="app-container">
    @if(showHeader()) {
    <app-header-mobile
      class="sticky-top"
      [hideSearch]="hideSearch()"
    ></app-header-mobile>
    <app-header class="sticky-top" [hideSearch]="hideSearch()"></app-header>
    }
    <main class="main">
      <router-outlet></router-outlet>
    </main>
    @if(isLoaded() && showFooter() && appSettings()) {
    <app-footer
      [appSettings]="appSettings()"
      [showAll]="showAllFooter()"
      class="footer"
    ></app-footer>
    }
  </div>
</block-ui>
} @else {
<div class="app-container">
  @if(showHeader()) {
  <app-header-mobile
    class="sticky-top"
    [hideSearch]="hideSearch()"
  ></app-header-mobile>
  <app-header class="sticky-top" [hideSearch]="hideSearch()"></app-header>
  }
  <main class="main">
    <router-outlet></router-outlet>
  </main>
  @if(isLoaded() && showFooter() && appSettings()) {
  <app-footer
    [appSettings]="appSettings()"
    [showAll]="showAllFooter()"
    class="footer"
  ></app-footer>
  }
</div>
}
